<influencer-module-container [title]="'INFLUENCER.overview.sponsored_vs_organic.title' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="301"
    [printMode]="printMode"
    [height]="printMode ? '225px' : '265px'">

    <div class="chart-area" [class.placeholder]="hasNoData" [class.print-mode]="printMode">
        <div class="chart-content">
            <chart [options]="options" (load)="saveInstance($event.context)"></chart>
        </div>

        <div class="legend-container organic" [class.unselected]="!isVisibleLegend('organic')" 
            (click)="clickLegend('organic')" (mouseover)="hoverLegend('organic')">
            <div *ngIf="hasNoData" class="legend-percentage">-%</div>
            <div *ngIf="!hasNoData" class="legend-percentage">{{organicPercentage | percentNumberSuffix}}</div>
            <div class="legend-title">
                <span>{{'INFLUENCER.overview.sponsored_vs_organic.organic' | translate}}</span>
                <div class="legend-color" [style.background-color]="isVisibleLegend('organic') ? organicColor : null" 
                    [class.d-none]="hasNoData"></div>
            </div>
        </div>

        <div class="legend-container sponsored" [class.unselected]="!isVisibleLegend('sponsored')" 
            (click)="clickLegend('sponsored')" (mouseover)="hoverLegend('sponsored')">
            <div *ngIf="hasNoData" class="legend-percentage">-%</div>
            <div *ngIf="!hasNoData" class="legend-percentage">{{sponsoredPercentage | percentNumberSuffix}}</div>
            <div class="legend-title">
                <span>{{'INFLUENCER.overview.sponsored_vs_organic.sponsored' | translate}}</span>
                <div class="legend-color" [style.background-color]="isVisibleLegend('sponsored') ? sponsoredColor : null" 
                    [class.d-none]="hasNoData"></div>
            </div>
        </div>
    </div>

</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/sponsored-vs-organic/sponsored-vs-organic.component.html